<template>
    <div>
        
        <h6 class="heading-small text-muted mb-4">ACCOUNT LICENSE SETTINGS</h6>
        
        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <base-alert v-if="messages != null" type="success">
            {{messages}}
        </base-alert>

        <form>
            <div class="row">
                <div class="col-lg-6">
                    <base-input alternative="" min="0" type="number" label="No. of License" input-classes="form-control" v-model="inputNoOfTerminal"  />
                </div>
                <div class="col-lg-6">
                    <base-input alternative="" min="0" type="number" label="No. of User" input-classes="form-control" v-model="inputNoOfUser"  />
                </div>
                <div class="col-lg-12">
                    <base-input alternative="" min="0" type="number" label="No. of Concurrent User (HO)" input-classes="form-control" v-model="maxConcurrentUserHo"  />
                </div>
            </div>
        </form>

        <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
            <button type="button" class="btn btn-success float-right" @click.prevent="saveAccountSetting">Save Settings</button>
       </div> 

    </div>
</template>


<script>
// import axios from "axios";
import HTTPRequest from '../../../controllers/httpRequest.js'
import { mapState } from 'vuex'
// import secureStorage from '../../../controllers/secureStorage';
// var component_x;
export default {
    computed: {
        ...mapState(['endPoint']),
    },
    data: function(){
        return {
            inputNoOfTerminal: 0,
            inputNoOfUser: 0,
            maxConcurrentUserHo: 0,
            errors: [],
            messages: null,
        }
    },
    props: ['accountId'],
    methods: {
        async saveAccountSetting(){
        let confirmation = prompt("Please input admin password to change account settings");
        if (confirmation == '123456'){
          var settingPayload = { settings: [
                                    {code: "no_of_license", name: "Number of License", value: this.inputNoOfTerminal, status: 'A'},
                                    {code: "no_of_user", name: "Number of User", value: this.inputNoOfUser, status: 'A'},
                                    {code: "max_concurrent_ho", name: "Max Concurrent Users HO", value: this.maxConcurrentUserHo, status: 'A'}
                                ],
                                account_id: this.accountId
                               }    
          var updateSetting = await HTTPRequest.postRequest(this.endPoint + 'settings/mass_create', null, settingPayload)
          this.messages = updateSetting["message"]
          document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
          this.$emit('updateAvailableLicense')
        //   console.log(updateSetting)
        } else {
          alert("Invalid Password")
        }
      }
    },
    mounted: async function(){
        // component_x = this;
        let params = null
        if(this.accountId != null){
            params = '?account_id=' + this.accountId 
        }
        var getSetting = await HTTPRequest.getRequest(this.endPoint + `settings/account_settings${params}`, null, null)
        this.inputNoOfTerminal = getSetting["no_of_license"]
        this.inputNoOfUser = getSetting["no_of_user"]
        this.maxConcurrentUserHo = getSetting["max_concurrent_ho"]

        // console.log(getSetting)
    }
}
</script>

<style>
</style>